export var WEB = 'WEB';
export var IOS = 'IOS';
export var WATCHOS = 'WATCHOS';
export var ANDROID = 'ANDROID';
